import { useTheme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { DescendArrow } from "../../../../assets/icons";
import { MyTeamSurveySummaryDTO } from "../../../../models/my-team-survey-summary/my-team-survey-summary-dto";
import CircleAndIconContainer from "../../reusable-widget-link-components/CircleAndIconContainer/CircleAndIconContainer";

const ProgressingSlowlyLink = ({
  customSummary,
  loading,
}: {
  customSummary: MyTeamSurveySummaryDTO;
  loading: boolean;
}) => {
  const tRP = "components.custom_widget_links.employee_surveys.progressing_slowly";
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <CircleAndIconContainer
      mainInfo={customSummary?.surveysProgressingSlowly?.toString() ?? "0"}
      description={`${t(`${tRP}`)}`}
      Icon={DescendArrow}
      IconStyle={{
        color: theme.palette.error.main,
        width: "90%",
        height: "90%",
      }}
      loading={loading}
      descriptionStyle={{
        width: "min-content",
      }}
    />
  );
};
export default ProgressingSlowlyLink;
